export default "__VITE_ASSET__D_sq495K__"